import { createRoot } from "solid-js";
import { showCommandline } from "../../states/commandline";
import { hotkeys } from "../../states/hotkeys";
import { isAnyPopupVisible } from "../../utils/misc";
import { createHotkey } from "./utils";

function openCommandline(): void {
  if (isAnyPopupVisible()) return;
  showCommandline();
}

createRoot(() => createHotkey(() => hotkeys.commandline, openCommandline));
createRoot(() => createHotkey("Mod+Shift+P", openCommandline));
